import { render, staticRenderFns } from "./purchase-order-v2.vue?vue&type=template&id=9b4d8b90&"
import script from "./purchase-order-v2.vue?vue&type=script&lang=js&"
export * from "./purchase-order-v2.vue?vue&type=script&lang=js&"
import style0 from "./purchase-order-v2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports